import React from 'react';
import classNames from 'classnames';

const ErrorMessage: React.FC<any> = ({ message = 'Something goes wrong!', className }) => {
  const errorClasses = classNames('error-message coral', {
    [`${className}`]: className,
  });

  return <div className={errorClasses}>{message}</div>;
};

export default ErrorMessage;
